import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    http
      .post("/auth/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Welcome, ${data.name.split(" ")[0]}`);
      })
      .catch(() => toast.error("Sign-in failed. Please try again."))
      .finally(() => navigate(location.pathname + location.search, { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="h-10 w-10 rounded-full border-2 border-[#E07A5F] border-t-transparent animate-spin" />
    </div>
  );
};
